import styles from "./File.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import ArrowDownToBaseIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowDownToBaseIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";

type FileProps = {
  name: string;
  size: string;
  onDownload: () => void;
};

export function File({ name, size, onDownload }: FileProps) {
  const { t } = useTranslation();

  return (
    <div className={styles["file"]}>
      <FixaButton
        iconOnly
        ssrIcon={ArrowDownToBaseIconPath}
        onClick={onDownload}
        size="small"
        aria-label={`${t("downloadString")} ${name}`}
      />
      <div>
        <div className={styles["fileName"]} onClick={onDownload}>
          <FixaText textStyle="Heading.XS">{name}</FixaText>
        </div>
        <FixaText textStyle="Body.M">{size}</FixaText>
      </div>
    </div>
  );
}
